/**
 * 处理上传请求
 * Content-Type: multipart/form-data
 * data: new FormData
 */
import axios from 'axios';
import { message } from 'antd';
import history from '../common/history'

export default function request(options) {
  let { data, url, method = 'get' } = options



  let headers = {
    "Content-Type": 'multipart/form-data'
  }

  if (sessionStorage.getItem("token")) {
    headers['Authorization'] = sessionStorage.getItem("token");
  }




  return axios.post(url, data, { headers })
    .then(response => {
      console.log('response', response);
      const { data, status } = response

      let result = {}
      result = data;

      console.log(result);


      if (status === 200) {
        return Promise.resolve(result)
      }else if (status === 400) {

      }else {
        if (status === 401) {
          console.log(result)
          history.replace('/login');
          return Promise.reject({
            success: false,
            data: {},
            code: result.code,
            message: result.message,
          })
        } else {
          message.error(`${message}`)
          return Promise.reject({
            success: false,
            data: {},
            code: result.code,
            message: result.message,
          })
        }
      }
    })
}


// WEBPACK FOOTER //
// ./src/utils/upload.js